webpackJsonp([24],{

/***/ 619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(70);

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Notifications",
  data: function data() {
    return {
      enableNotificationsButtons: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(["user"])),
  mounted: function mounted() {
    if ("Notification" in window) {
      this.enableNotificationsButtons = true;
    }
  },
  methods: {
    toggleNotifications: function toggleNotifications() {
      this.$store.commit("SET_NOTIFICATIONS", !this.user.notifications);
    },
    askForNotificationPermission: function askForNotificationPermission() {
      self = this;
      if (this.user.notifications) {
        Notification.requestPermission(function (result) {
          console.log("User choice", result);
          if (result !== "granted") {
            console.log("No notification permission granted!");
          } else {
            self.displayConfirmNotification();
          }
        });
      }
    },
    displayConfirmNotification: function displayConfirmNotification() {
      console.log("display notif 1");
      if ("serviceWorker" in navigator) {
        var options = {
          body: "You successfully subscribed to our notification service!",
          icon: "../../static/img/icons/android-chrome-96x96.png",
          //image: "../../static/img/icons/android-chrome-96x96.png",
          vibrate: [30, 30, 30, 30, 30],
          badge: "../../static/img/icons/android-chrome-96x96.png",
          tag: "confirm-notification", // if another notification is created with the same tag, it will replace the former one
          renotify: false, // not vibrate again
          actions: [{
            action: "confirm",
            title: "Ok",
            icon: "../../static/img/icons/android-chrome-96x96.png"
          }, {
            action: "cancel",
            title: "Cancel",
            icon: "../../static/img/icons/android-chrome-96x96.png"
          }]
        };
        console.log("display notif 2");
        //new Notification("Successfully subscribed!", options);
        navigator.serviceWorker.ready.then(function (swreg) {
          console.log(swreg);
          console.log("display notif 3");
          swreg.showNotification("Successfully subscribed!(from SW)", options);
        });
      }
    }
  }
});

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(578)(true);
// imports


// module
exports.push([module.i, ".switch-on[data-v-5d31a2ec]{background:url(" + __webpack_require__(580) + ") no-repeat -281px -29px;width:29px;height:25px;margin-top:3px}.switch-off[data-v-5d31a2ec]{margin-left:-13px;background:url(" + __webpack_require__(580) + ") no-repeat -323px -29px;width:30px;height:25px;margin-top:3px}", "", {"version":3,"sources":["D:/Google Drive/Travail/Mes projets/firewords2/src/components/Notifications.vue"],"names":[],"mappings":"AAuFA,4BACE,gEAAwE,AACzE,WAAY,AACZ,YAAa,AACZ,cAAgB,CACjB,AACD,6BACE,kBAAmB,AACnB,gEAAwE,AACzE,WAAY,AACZ,YAAa,AACZ,cAAgB,CACjB","file":"Notifications.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n/*{border:solid 1px red}*/\n.switch-on[data-v-5d31a2ec] {\r\n  background: url(\"../../static/img/sprite-2.svg\") no-repeat -281px -29px;\r\n\twidth: 29px;\r\n\theight: 25px;\r\n  margin-top: 3px;\n}\n.switch-off[data-v-5d31a2ec] {\r\n  margin-left: -13px;\r\n  background: url(\"../../static/img/sprite-2.svg\") no-repeat -323px -29px;\r\n\twidth: 30px;\r\n\theight: 25px;\r\n  margin-top: 3px;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(643);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(579)("4bde99dc", content, true);

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(672)
}
var Component = __webpack_require__(69)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(718),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d31a2ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 718:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.enableNotificationsButtons) ? _c('v-layout', {
    on: {
      "click": _vm.askForNotificationPermission
    }
  }, [_c('v-flex', {
    on: {
      "click": _vm.toggleNotifications
    }
  }, [_c('div', {
    staticClass: "pb-2 h2-dark",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "dark-window pa-3 center",
    staticStyle: {
      "margin-top": "-18px",
      "overflow": "hidden",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    class: {
      'switch-on': _vm.user.notifications, 'switch-off': !_vm.user.notifications
    }
  })])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/24.ac976d10c034b582c17a.js